export default "__VITE_ASSET__BOjLLq45__"